import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { BonusList } from 'src/app/shared/interfaces/bonus.interface';
import { CurrenciesInterface } from 'src/app/shared/interfaces/deposit.interface';
import { TokenAddress } from 'src/app/shared/interfaces/tokenaddress.interface';
import {
  OpenWalletTransferResult,
  WalletPopupClose,
  WalletPopupClosePayload,
} from 'src/app/shared/interfaces/wallet.interface';

export type WalletEvent<T> = null | BaseWalletEvent<T>;

interface BaseWalletEvent<T> {
  from: string;
  data: T;
}

@Injectable({
  providedIn: 'root',
})
export class WalletService {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
  ) {}

  openWalletTransferResult$: BehaviorSubject<OpenWalletTransferResult> = new BehaviorSubject<OpenWalletTransferResult>({
    isOpen: false,
    transferSuccessData: null,
  });

  closePayload: WalletPopupClosePayload = {};

  /** 主钱包单独选择想要充值提现的币种 不使用预设币种 */
  seletedWalletTyepAndCurrency$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  /** 選中的紅利 */
  seletedDividend$: BehaviorSubject<BonusList | null | undefined> = new BehaviorSubject<BonusList | null | undefined>(
    undefined,
  );

  /** 選取的紅利ID */
  selectedBonusActivityNo$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  /** 不選擇紅利開關 */
  unSelectedAllBonus: boolean = false;

  /**
   * 打开弹窗 到划转
   *
   * @param category
   * @returns Observable<WalletPopupClose>
   */
  popupOpenTransfer(category: string): Observable<WalletPopupClose> {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { type: 'walletTransfer', category },
      fragment: 'wallet',
    });
    // 抓取一次关闭动作
    return this.appService.walletPopupClose$.pipe(
      filter(e => e.page === 'walletTransfer'),
      take(1),
    );
  }

  /**
   * 打开对应弹窗
   *
   * @param currency 默认货币
   * @param type 页面类型
   */
  popupOpen(currency?: string, type?: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { currency, type },
      fragment: 'wallet',
    });
  }

  addAddressEvent$ = new BehaviorSubject<WalletEvent<boolean>>(null);
  selectCurrencyEvent$ = new BehaviorSubject<WalletEvent<CurrenciesInterface>>(null);
  selectAddressEvent$ = new BehaviorSubject<WalletEvent<TokenAddress>>(null);
  selectBankEvent$ = new BehaviorSubject<WalletEvent<any>>(null);
  addBankcardEvent$ = new BehaviorSubject<WalletEvent<boolean>>(null);
  addAlipayEvent$ = new BehaviorSubject<WalletEvent<boolean>>(null);
}
